
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.554 5.886c-.634.322-1.2.742-1.702 1.262a7.254 7.254 0 00-1.498 2.296 7.051 7.051 0 00-.534 2.72c0 1.021.18 1.938.524 2.763.352.839.837 1.56 1.458 2.172a6.616 6.616 0 002.208 1.425c.84.334 1.769.507 2.795.507.717 0 1.4-.1 2.051-.3l.006-.002a6.875 6.875 0 003.274-2.118c.3-.356.552-.733.758-1.132a8.318 8.318 0 01-2.214.295c-1.093 0-2.11-.16-3.037-.498l-.002-.001a6.706 6.706 0 01-2.4-1.488l-.007-.006a6.658 6.658 0 01-1.526-2.358v-.002c-.354-.918-.52-1.928-.52-3.015a9.26 9.26 0 01.263-2.143v-.002l.97.239-.971-.235v-.002c.032-.129.066-.255.104-.377zm.258-2.234c.142-.028.3-.05.461-.05.405 0 .844.136 1.171.509.259.29.4.652.4 1.045 0 .186-.03.362-.072.52l-.004.014c-.046.166-.112.329-.186.484l-.003.006a2.79 2.79 0 00-.185.555l-.001.004a7.258 7.258 0 00-.206 1.667c0 .882.136 1.643.387 2.297.253.655.61 1.202 1.064 1.654a4.71 4.71 0 001.689 1.04c.676.245 1.456.376 2.353.376.395 0 .775-.034 1.14-.1.375-.07.647-.145.832-.217.3-.137.643-.245 1.004-.245.407 0 .786.155 1.075.45.321.315.449.72.449 1.105 0 .157-.022.317-.048.46l-.001.008a2.524 2.524 0 01-.182.562 7.985 7.985 0 01-1.286 2.107l-.003.003a8.875 8.875 0 01-4.222 2.738 8.974 8.974 0 01-2.633.387c-1.256 0-2.437-.212-3.534-.649a8.615 8.615 0 01-2.869-1.855l-.002-.002a8.574 8.574 0 01-1.9-2.826c-.458-1.093-.68-2.275-.68-3.535 0-1.212.228-2.375.685-3.483a9.254 9.254 0 011.908-2.922A8.37 8.37 0 019.311 3.8l.017-.007.018-.006c.15-.055.303-.1.456-.133l.01-.002z","fill":"currentColor"}})])
          )
        }
      }
    